import { useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { TableRow, TableCell, MenuItem } from '@mui/material';
// components

import useLocales from 'src/hooks/useLocales';

import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import Iconify from 'src/components/Iconify';
import { TableMoreMenu } from 'src/components/table';
import { Incomes } from 'src/@types/Choqorak/MainTables/Income/Income';
import { DateConverter } from 'src/sections/common/DateConverter';
import { GetCurrencySymbol } from 'src/sections/common/GetCurrencySymbol';
// ----------------------------------------------------------------------

type Props = {
  row: Incomes;
  // selected: boolean;
  onEditRow: VoidFunction;
  //onSelectRow: VoidFunction;
  handleDetail: VoidFunction;
  onDeleteRow: VoidFunction;
  index: any;
};

export default function IncomeTableRow({ row, onEditRow, onDeleteRow, index, handleDetail }: Props) {
  const theme = useTheme();

  const {
    incomeId: id,
    incomeCategoryId,
    amount,
    recieveDate,
    incomeCategory,
    carrencyType,
    description
  } = row;
  const { translate } = useLocales();
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableRow hover>
      <TableCell align="left">{index + 1}</TableCell>
      <TableCell align="left">{<DateConverter date={recieveDate} />}</TableCell>

      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {incomeCategory}
      </TableCell>
      {/* <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {carrencyType}
      </TableCell> */}

      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {amount}{' '}
        {row.carrencyId === 2
          ? GetCurrencySymbol('afn')
          : GetCurrencySymbol('dollar')}
      </TableCell>
      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {description}
      </TableCell>
      <TableCell align="left">
        <TableMoreMenu
          open={openMenu}
          onOpen={handleOpenMenu}
          onClose={handleCloseMenu}
          actions={
            <>
              <PermissionBasedGuard permissions={['Income-Delete']}>
                <MenuItem
                  onClick={() => {
                    onDeleteRow();
                    handleCloseMenu();
                  }}
                  sx={{ color: 'error.main' }}
                >
                  <Iconify icon={'eva:trash-2-outline'} />
                  {translate('CRUD.Delete')}
                </MenuItem>
              </PermissionBasedGuard>
              <PermissionBasedGuard permissions={['Income-Update']}>
                <MenuItem
                  onClick={() => {
                    onEditRow();
                    handleCloseMenu();
                  }}
                >
                  <Iconify sx={{ color: 'warning.main' }} icon={'eva:edit-fill'} />
                  {translate('CRUD.Update')}
                </MenuItem>
              </PermissionBasedGuard>
              <PermissionBasedGuard permissions={['Income-GetDetail']}>
                <MenuItem
                  onClick={() => {
                    handleDetail();
                    handleCloseMenu();
                  }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                  {translate('Employee.Details')}
                </MenuItem>
              </PermissionBasedGuard>
            </>
          }
        />
      </TableCell>
    </TableRow>
  );
}
